import { useEffect, useState } from 'react';
import { InteractionStatus } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import { consumeReturnPath } from './session';

export function AuthCallback() {
  const { instance, accounts, inProgress } = useMsal();
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (inProgress !== InteractionStatus.None) {
      return;
    }

    const account = instance.getActiveAccount() ?? accounts[0] ?? null;
    if (!account) {
      setFailed(true);
      return;
    }

    instance.setActiveAccount(account);
    navigate(consumeReturnPath(), { replace: true });
  }, [accounts, inProgress, instance, navigate]);

  if (failed) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white text-small text-red-700">
        Authentication failed
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-white text-small text-neutral-600">
      Completing sign in...
    </div>
  );
}
